import { render } from "./PastCohorts.vue?vue&type=template&id=058a1bb2&scoped=true"
import script from "./PastCohorts.vue?vue&type=script&lang=js"
export * from "./PastCohorts.vue?vue&type=script&lang=js"

import "./PastCohorts.vue?vue&type=style&index=0&id=058a1bb2&lang=scss&scoped=true"

import exportComponent from "/home/deploy/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058a1bb2"]])

export default __exports__